import { useState } from "react";
import "./App.css";
import logo from "./logo-autobooker.png";

import auto1 from "./rentals/wake-up-rent-car/auto1.jpg";
import auto2 from "./rentals/wake-up-rent-car/auto2.jpg";
import auto3 from "./rentals/wake-up-rent-car/auto3.jpg";
import auto4 from "./rentals/wake-up-rent-car/auto4.jpg";
import auto5 from "./rentals/wake-up-rent-car/auto5.jpg";
import auto6 from "./rentals/wake-up-rent-car/auto6.jpg";
import auto7 from "./rentals/wake-up-rent-car/auto7.jpg";

export default function App() {
  const [region, setRegion] = useState("");
  const [page, setPage] = useState("home");
const [showContact, setShowContact] = useState(false);
  return (
    <div className="app">
      <header className="navbar">
        <div className="logo">
          <img src={logo} alt="AutoBooker" className="logo-img" />
        </div>

        <nav>
          
          <a href="/">Wypożyczalnie</a>
          <a href="/">Lokalizacje</a>
          <a href="/">FAQ</a>
          <a href="/">Kontakt</a>
        </nav>

        <div className="nav-right">
          
  <div className="nav-right">

  <button className="favorites-btn">
    ♡ Ulubione
  </button>

 <button
  type="button"
  className="add-btn"
  onClick={() => setShowContact(true)}
>
  Dodaj wypożyczalnię
</button>

</div>
        </div>
      </header>

      {page === "home" && (
        <section className="hero">
          <div className="hero-overlay"></div>

          <div className="hero-content">
            <h1>
              Znajdź idealne auto <br />
              <span>na każdą podróż</span>
            </h1>

            <p className="hero-text">
              Porównuj oferty lokalnych wypożyczalni, rezerwuj szybciej i podróżuj bez stresu.
            </p>

            <div className="search-box">
              <div className="search-item">
                <label>Lokalizacja odbioru</label>
                <select
                  className="location-select"
                  value={region}
                  onChange={(e) => setRegion(e.target.value)}
                >
                  <option value="">Wybierz województwo</option>
<option value="Dolnośląskie">Dolnośląskie</option>
<option value="Kujawsko-pomorskie">Kujawsko-pomorskie</option>
<option value="Lubelskie">Lubelskie</option>
<option value="Lubuskie">Lubuskie</option>
<option value="Łódzkie">Łódzkie</option>
<option value="Małopolskie">Małopolskie</option>
<option value="Mazowieckie">Mazowieckie</option>
<option value="Opolskie">Opolskie</option>
<option value="Podkarpackie">Podkarpackie</option>
<option value="Podlaskie">Podlaskie</option>
<option value="Pomorskie">Pomorskie</option>
<option value="Śląskie">Śląskie</option>
<option value="Świętokrzyskie">Świętokrzyskie</option>
<option value="Warmińsko-mazurskie">Warmińsko-mazurskie</option>
<option value="Wielkopolskie">Wielkopolskie</option>
<option value="Zachodniopomorskie">Zachodniopomorskie</option>
                </select>
              </div>

              <div className="search-item">
                <label>Odbiór</label>
                <input
                  type="text"
                  className="date-field"
                  placeholder="Wybierz datę"
                  onFocus={(e) => (e.target.type = "date")}
                  onBlur={(e) => {
                    if (!e.target.value) e.target.type = "text";
                  }}
                />
              </div>

              <div className="search-item">
                <label>Zwrot</label>
                <input
                  type="text"
                  className="date-field"
                  placeholder="Wybierz datę"
                  onFocus={(e) => (e.target.type = "date")}
                  onBlur={(e) => {
                    if (!e.target.value) e.target.type = "text";
                  }}
                />
              </div>

              <div className="search-item">
                <label>Typ samochodu</label>
                <select>
                  <option>Wybierz typ auta</option>
                  <option>SUV</option>
                  <option>Premium</option>
                  <option>Bus</option>
                  <option>Rodzinne</option>
                </select>
              </div>

              <button
                type="button"
                className="search-btn"
                onClick={() => {
                  if (region === "Warmińsko-mazurskie") {
                    setPage("results");
                    window.scrollTo(0, 0);
                  }
                }}
              >
                Szukaj ofert
              </button>
            </div>

            <div className="features-row">
              <span>▰ Najlepsze ceny</span>
              <span>♡ Sprawdzone wypożyczalnie</span>
              <span>⚡☎ Kontakt bez pośredników </span>
            </div>
          </div>
        </section>
      )}

      {page === "results" && (
        <div className="results-page">
          <button
  type="button"
  className="back-btn"
  onClick={() => {
    window.location.reload();
  }}
>
  ← Wróć do wyszukiwarki
</button>

          <h2>Wyniki wyszukiwania</h2>

          <div className="rental-result-card">
            <h3>Wake Up Rent Car</h3>
            <p>Węgorzewo • woj. warmińsko-mazurskie • 7 samochodów dostępnych</p>

            <button
              type="button"
              className="view-offer-btn"
              onClick={() => {
                setPage("offer");
                window.scrollTo(0, 0);
              }}
            >
              Zobacz ofertę
            </button>
          </div>
        </div>
      )}

      {page === "offer" && (
        <div className="offer-page">
          <button
  type="button"
  className="back-btn"
  onClick={() => {
    setPage("results");
  }}
>
  ← Wróć do wyników
</button>

          <div className="offer-header">
            <h2>Wake Up Rent Car</h2>
            <div className="offer-info">
              <div>📍 Węgorzewo, woj. warmińsko-mazurskie</div>
              <div>📞 tel. 575 718 222</div>
            </div>
          </div>

          <h3 className="offer-title">Dostępne samochody</h3>

          <div className="offer-cars-grid">
            {[auto1, auto2, auto3, auto4, auto5, auto6, auto7].map((auto, index) => (
              <div className="car-card" key={index}>
                <img src={auto} alt={`Auto ${index + 1}`} />
              </div>
            ))}
          </div>

          <p className="price-note">
            ℹ️ Ceny mogą się różnić w zależności od terminu i długości wynajmu.
          </p>
        </div>
      )}
    {showContact && (
  <div className="contact-overlay">
    <div className="contact-box">

      <button
        type="button"
        className="contact-close"
        onClick={() => setShowContact(false)}
      >
        ×
      </button>

      <h2>Dodaj swoją wypożyczalnię</h2>

      <p>
        Napisz do nas i dodaj swoją ofertę do AutoBooker.
      </p>

      <div className="contact-email">
        autobooker.pl@gmail.com
      </div>

      <a
        className="contact-mail-btn"
        href="mailto:autobooker.pl@gmail.com?subject=Chcę dodać wypożyczalnię do AutoBooker"
      >
        Napisz maila
      </a>

    </div>
  </div>
)}
    </div>
  );
}